import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-ver-registro-button',
  template: `
    <!-- VER REGISTRO -->
    <button *ngIf="mostrarVerRegistro"
            nbButton size="tiny" status="info"
            (click)="onVerRegistro()">
      VER REGISTRO
    </button>

    <!-- VER DETALLE -->
    <button *ngIf="mostrarVerDetalle"
            nbButton size="tiny" status="primary"
            (click)="onVerDetalle()" style="margin-left: 2px;">
      VER DETALLE
    </button>
  `
})
export class VerRegistroButtonComponent {

  @Input() rowData: any;

  @Output() verRegistro = new EventEmitter<any>();
  @Output() verDetalle = new EventEmitter<any>();

  get mostrarVerRegistro(): boolean {
    return this.rowData?.type?.metadata?.cueType !== undefined &&
           this.rowData?.status === 'FINALIZADA';
  }

  get mostrarVerDetalle(): boolean {
    return this.rowData?.status === 'INICIADA' ||
           this.rowData?.status === 'FINALIZADA';
  }

  onVerRegistro() {
    this.verRegistro.emit(this.rowData);
  }

  onVerDetalle() {
    this.verDetalle.emit(this.rowData);
  }
}